import React from 'react';
import {Button,/*Col,*/ Container} from 'reactstrap';
//import Modes from "../exercises/mode/Modes";
//import ModeItem from "./modeItem/ModeItem";
//import {getRandomIntegerWithRange} from "../exercises/Random";
//import {formatNumberForDisplay} from "../ui/NumberFormatter";
//import DebugHelperElement from "./DebugHelperElement";
//import ArithmeticElement from "./modes/ArithmeticElement";
//import Keyboard from "./keyboard/Keyboard";
//import Constants from "./constants";
import "../success-checkmark.css"
//import SuccessElement from "./SuccessElement";
import "../style/PracticePage.sass"
//import getModesFromURL from "../ModeURLParameterHelper";
import {LOCALSTORAGE_DISCLAIMER_ACCEPTED} from "./MainPage";
import "../style/WelcomePage.sass"
import {useNavigate} from "react-router-dom";

function WelcomePage(){
    const navigate = useNavigate()
    const accept = () => {
        localStorage.setItem(LOCALSTORAGE_DISCLAIMER_ACCEPTED, "true")
        navigate("/")
    }

    return <Container className="container h-100 d-flex">
        <div className="rounded px-3 px-sm-4 py-3 py-sm-5 my-auto">
            <h2>Zahlendarstellungs-Lern-App</h2>
            <h6>Frankfurt University of Applied Sciences</h6>
            <h6>Fachbereich 2 - Informatik</h6>
            <h6>Prof. Dr. Jens Liebehenschel, <a href="mailto:liebehenschel@fb2.fra-uas.de">liebehenschel@fb2.fra-uas.de</a>, +49 69 1533-3948</h6>
            <br/>
            <p>
                Die Ersteller und Betreiber dieser Webseite übernehmen keine Haftung
                für eventuelle Fehler und Probleme mit der Anwendung.
                Für die Korrektheit der Aufgaben und Lösungen wird ebenso keine Haftung übernommen.
            </p>
            <br/>
            <Button onClick={accept}>Akzeptieren und los</Button>
            <br/>
            <br/>
            <span className={"small-text-heading"}>Über die Zahlendarstellungs-Lern-App</span>
            <br/>
            <span className={"small-text"}>Idee und Konzeption: Prof. Dr. Jens Liebehenschel</span>
            <br/>
            <span className={"small-text"}>Entwicklung erste Version: Alexander Amin</span>
            <br/>
            <span className={"small-text"}>Weiterentwicklung: Alexander Amin, Prof. Dr. Jens Liebehenschel</span>
            <br/>
            <br/>
            <p className={"small-text"}>
                Die Zahlendarstellungs-Lern-App in der vorliegenden Form basiert auf zwei Vorgängerversionen.
                Die erste Version war ein Prototyp einer Android-App und wurde von Yalcin Eren entwickelt.
                Die zweite Version war eine Android-App, die gemeinsam von Alexander Amin und Yalcin Eren
                auf Basis des Prototypen entwickelt wurde.
            </p>
            <br/>
        </div>
    </Container>
}
export default WelcomePage
